import { EditTileGeneralFields } from "client/Features/Workspace/LeftSliders/EditTile/GeneralFields";
import {
	Button,
	Form,
	FormItem,
} from "client/Components";
import {
	ExistingTile,
} from "./common";
import {
	AddTilesResponseModel,
	AzureAppUpdateTileModel,
	AzureDetailsTileModel,
	updateAzureAppTile
} from "client/Api/Workspace/workspace";
import { IFormHandler, useFormHandler } from "client/Forms";
import { useUpdateTile } from "client/Features/Workspace/LeftSliders/EditTile/hooks/useUpdateTile";
import {
	forwardRef,
	Ref,
	useImperativeHandle,
	useState
} from "react";
import { EditTileFromData, initialGenericState } from "client/Features/Workspace/LeftSliders/EditTile/EditGenericTile";
import { createValidationConfiguration, IValidationConfiguration } from "client/Validation";
import { EditTileHandle } from "client/Features/Workspace/LeftSliders/EditTile/EditTile";
import { AppDestinationWindowSelectFormItem } from "client/Features/Apps/AppDestinationWindowSelectFormItem";
import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import * as windowFactory from "client_legacy/ndaw/windowFactory";
import { localize } from "client_legacy/ndaw/culture";
import {
	doesNotExceedLength,
	isNotEmpty,
	isNotNullNorUndefined
} from "client/Validation/rules";
import styles from "./EditAzureTile.module.less";
import { setTrackingId } from "client/Misc/utils";

type AzureEditFormData = EditTileFromData<AzureAppUpdateTileModel>;

export type EditAzureTileProps = {
	isLoading: boolean;
	onIsLoadingChange: (value: boolean) => void;
	initialModel: AzureDetailsTileModel;
	mode: ExistingTile;
	onAfterSave: (response?: AddTilesResponseModel) => void;
};

const validationBuilder: IValidationConfiguration<AzureEditFormData> =
	createValidationConfiguration<AzureEditFormData>();

validationBuilder
	.forScalar("name")
	.add(
		isNotNullNorUndefined(),
		isNotEmpty(),
		doesNotExceedLength(255)
	);

export const EditAzureTile = forwardRef(
	(props: EditAzureTileProps, ref: Ref<EditTileHandle>) => {
		const {
			initialModel,
			mode,
			onAfterSave,
			onIsLoadingChange,
			isLoading
		} = props;

		const [formData, setFormData] = useState<AzureEditFormData>({
			...initialGenericState(initialModel),
			destinationWindow: initialModel.destinationWindow
		});

		const formHandler: IFormHandler<AzureEditFormData> = useFormHandler(
			formData,
			setFormData,
			validationBuilder
		);

		const { updateHandler } = useUpdateTile<AzureAppUpdateTileModel>(
			formHandler,
			updateAzureAppTile,
			isLoading,
			onIsLoadingChange,
			mode,
			onAfterSave
		);

		const clickHandler = () => {
			const urlEndpoint: string = createUrlRelativeToEnvironment("Workspace/GoChangeCredentials/" + mode.id);
			windowFactory.open(urlEndpoint);
		};

		useImperativeHandle(
			ref,
			() => ({ updateHandler })
		);

		return (
			<Form
				onSubmit="NONE"
			>
				<EditTileGeneralFields
					initialModel={initialModel}
					formHandler={formHandler}
				/>
				<FormItem label={localize("_SSOUrl")}>
					<p {...setTrackingId("sso-url")} className={styles.url}>
						{initialModel.urlPrefix}{initialModel.urlSuffix}
					</p>
				</FormItem>
				<AppDestinationWindowSelectFormItem
					attachable={formHandler.for("destinationWindow")}
				/>
				<Button
					kind="primary"
					text={localize("_ChangeAppCredentials")}
					icon="key"
					onClick={clickHandler}
					trackingId="change-app-credential-button"
				/>
			</Form>
		);
	});

EditAzureTile.displayName= "EditAzureTile";